import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameService} from "../../../serverService/gameService/GameService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";

export default function GameBasicInfo({gameId}) {

    const [gameTitle, setGameTitle] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [updatedBy, setUpdatedBy] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");

    const [updateButtonLoading, setUpdateButtonLoading] = useState(false)

    const service = new GameService()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameBasicInfoFromServer()
        }
    }, [gameId]);


    function getGameBasicInfoFromServer() {
        service.getGameBasicInfo(gameId)
            .then(response => {
                setGameTitle(response.title)
                setCreatedBy(response.createdBy)
                setUpdatedAt(convertUniversalDateTimeToPersianDateTime(response.updatedAt))
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setUpdatedBy(response.updatedBy)
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }

    function handleUpdateGameBasicInfo() {
        setUpdateButtonLoading(true)
        service.updateGameBasicInfo(gameId, gameTitle)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setUpdateButtonLoading(false)
        })


    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonLoadingState={updateButtonLoading}
                    actionButtonOnclickWithValidation={handleUpdateGameBasicInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان بازی"}
                            value={gameTitle}
                            setValue={setGameTitle}
                            required
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
            <RaikoCreatorInfo
                title={"آخرین بروزرسانی"}
                createdByTitle={"ادمین"}
                createdBy={updatedBy}
                createdAtTitle={"تاریخ بروزرسانی"}
                createdAt={updatedAt}/>
        </RaikoGridOneColumn>
    )
}